import { render, staticRenderFns } from "./statistics-breakdown-card.vue?vue&type=template&id=a9a68756&scoped=true"
import script from "./statistics-breakdown-card.vue?vue&type=script&lang=js"
export * from "./statistics-breakdown-card.vue?vue&type=script&lang=js"
import style0 from "./statistics-breakdown-card.vue?vue&type=style&index=0&id=a9a68756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a68756",
  null
  
)

export default component.exports